import { CrudActions, EntityTypeEnum, WorkflowActions } from 'api'
import { Translation } from 'locale'
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { EntityTypeIdRecord, NotificationType } from 'store/notification/notificationTypes'
import { useModal } from 'view/shared/modal'
import { HaircutDialog } from './HaircutDialog/HaircutDialog'

export const useNewHaircutDialog = () => {
  const dispatch = useDispatch()
  const { showModal } = useModal()

  const addNewHaircut = useCallback(() => {
    const correlatedResponseCallback = (workflowId: string, newlyAddedEntityIdAndTypes: EntityTypeIdRecord) => {
      showModal(<HaircutDialog workflowId={workflowId} entityId={newlyAddedEntityIdAndTypes[EntityTypeEnum.HAIRCUT_ENTRY]} />)
    }

    dispatch(WorkflowActions.createNewWorkflow(EntityTypeEnum.HAIRCUT_ENTRY, correlatedResponseCallback))
  }, [dispatch, showModal])

  return addNewHaircut
}

export const useEditHaircutDialog = () => {
  const dispatch = useDispatch()
  const { showModal } = useModal()

  const editHaircut = useCallback(
    (haircutId: string) => {
      const correlatedResponseCallback = (workflowId: string) => {
        showModal(<HaircutDialog workflowId={workflowId} entityId={haircutId} />)
      }

      dispatch(WorkflowActions.createEditWorkflow(EntityTypeEnum.HAIRCUT_ENTRY, haircutId, correlatedResponseCallback))
    },
    [dispatch, showModal]
  )

  return editHaircut
}

export const useCloneHaircutDialog = () => {
  const dispatch = useDispatch()
  const { showModal } = useModal()

  const editHaircut = useCallback(
    (haircutId: string) => {
      const correlatedResponseCallback = (workflowId: string, newlyAddedEntityIdAndTypes: EntityTypeIdRecord) => {
        showModal(<HaircutDialog workflowId={workflowId} entityId={newlyAddedEntityIdAndTypes[EntityTypeEnum.HAIRCUT_ENTRY]} />)
      }

      dispatch(WorkflowActions.createCloneWorkflow(EntityTypeEnum.HAIRCUT_ENTRY, haircutId, correlatedResponseCallback))
    },
    [dispatch, showModal]
  )

  return editHaircut
}

export const useDeleteHaircut = () => {
  const dispatch = useDispatch()
  const { showDialog } = useModal()

  const onDelete = async (haircutIds: string[]) => {
    const dialogArgs = {
      type: NotificationType.Confirm,
      title: haircutIds.length === 1 ? Translation.TC_DELETE_HAIRCUT_ENTRY : Translation.TC_DELETE_HAIRCUT_ENTRIES,
      message:
        haircutIds.length === 1 ? Translation.SC_DELETE_HAIRCUT_ENTRY_CONFIRMATION : Translation.SC_DELETE_HAIRCUT_ENTRIES_CONFIRMATION,
      buttons: [Translation.TC_BUTTON_YES, Translation.TC_BUTTON_NO],
      defaultButton: Translation.TC_BUTTON_YES,
      cancelButton: Translation.TC_BUTTON_NO
    }
    const dialogResult = await showDialog(dialogArgs)

    if (dialogResult === Translation.TC_BUTTON_YES) {
      haircutIds.forEach(haircutId => {
        dispatch(CrudActions.haircutEntryDelete(haircutId))
      })
    }
  }

  return onDelete
}
